

// ======================== VALIDACION ========================
window.lpad = function (texto, longitud, caracter) {
	while (texto.length < longitud)
		texto = caracter + texto;
	return texto;
}

window.rpad = function (texto, longitud, caracter) {
	while (texto.length < longitud)
		texto += caracter;
	return texto;
}

//======================== FECHAS ========================
window.validateInitialDate = function ($el, fecDesde, fecHasta) {
	const momentFecHasta = parseDateTime(fecHasta).utc();

	if (momentFecHasta != null) {
		const momentFecDesde = parseDateTime(fecDesde).utc();

		if (compareDate(momentFecDesde, momentFecHasta) == 1) {
			$('#fecHasta').val("");
		}
	}

	return !(obligFecha && $el.value == "" && $el.value == null);
}

window.validateFinalDate = function ($el, fecDesde, fecHasta, errorElement) {
	errorElement.html(polyglot.t("Please_select_the_date"));
	const momentFecDesde = parseDateTime(fecDesde).utc();

	if (!(obligFechaHasta && $el.value == "" && $el.value == null)) {
		const momentFecHasta = parseDateTime(fecHasta).utc();

		if (momentFecHasta != null && compareDate(momentFecDesde, momentFecHasta) == 1) {
			errorElement.html(polyglot.t("Please_select_a_correct_date"));
			return false;
		}
	}
	else
		return false;

	return true;
}

window.validateDatePicker = function (fromDateVal, untilDateVal, untilEl, untilErrEl) {
	if (fromDateVal > untilDateVal) {
		untilErrEl.html(polyglot.t("Please_select_a_correct_date"));
		untilErrEl.show();
		untilEl.addClass('is-invalid-input');
		untilEl.attr('data-invalid', '');
		untilEl.attr('data-invalid-date', '');
	}
	else 
	{
		untilErrEl.hide();
		untilEl.removeClass('is-invalid-input');
		untilEl.removeAttr('data-invalid', '');
		untilEl.removeAttr('data-invalid-date', '');
	}
}

window.validateSubmitPicker = function (dateEl, callback) {
	if (dateEl.attr('data-invalid-date') != undefined || dateEl.attr('data-invalid') != undefined) {
		dateEl.addClass('is-invalid-input');
		dateEl.attr('data-invalid', '');
		return false;
	}

	callback();
}

window.validateDatePicker0 = function (dateEl) {
	if (dateEl == null) 
	{
		return false;
	}

	if (dateEl.attr('data-invalid-date') != undefined || dateEl.attr('data-invalid') != undefined) 
	{
		dateEl.addClass('is-invalid-input');
		dateEl.attr('data-invalid', '');
		return false;
	}

	return true;
}


window.validateHhMm = function (inputField) {
	const isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(inputField.value);

	if (!isValid) {
		inputField.addClass('is-invalid-input');
		inputField.attr('data-invalid', '');
	}

	return isValid;
}
window.validateFriendlyUrl = function (friendlyUrl) {
	return friendlyUrl.replace(/[^a-zA-Z0-9\-]/g, "");
}